import React, { useEffect, useState } from "react";
import MainLayout from "../../components/layout/MainLayout";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import Login from "../../app/auth/Login";
import './Output.scss'

import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import Card from "../../components/reuseable/Card";
import Table from "../../components/reuseable/Table";
import { useLocation } from "react-router-dom";
const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  padding: theme.spacing(2, 0),
  ...theme.mixins.toolbar,
}));


const Output = () => {
  const [outputData, setoutputData] = useState();
  const [loading, setloading] = useState(false);
  const [error, seterror] = useState(false);
  const [errorCode, seterrorCode] = useState();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const responseID = queryParams.get("responseID");

  console.log(responseID); // Logs: 1541b6c5-33cb-4990-9ac7-eb4d388688aa
  console.log(outputData && outputData['data']['compliance_assessment'])

  const CompliantData = outputData?.data?.compliance_assessment || [];

  const CompliantLength = CompliantData.filter(item => item.compliance_status === 'Compliant').length;
  const NonCompliantLength = CompliantData.filter(item => item.compliance_status === 'Non-Compliant').length;
  const AnalysedLength = CompliantData.filter(item => item.compliance_status === 'Analysed').length;


  const getOutputData = async () => {
    setloading(true);
    const url = `${process.env.REACT_APP_PYTHON_BACKEND_URL}/output/${responseID}`;

    await fetch(`${url}`)
      .then((response) => {
        if (response.status === 200) {
          response.json().then((json) => {
          console.log(json)
          setoutputData(json)
          setloading(false);

          });
        }
      })
      .catch((err) => {
        setloading(false);
        seterror(true);
        console.log(err);
      });
  };

  useEffect(() => {
    getOutputData();
  }, []);

  const compliance_assessment_header = ['S.No','Compliance Status','Observations','Policy Section','Actions']


  return (
    <>
      <AuthenticatedTemplate>
        <div
          id="homePage"
          style={{ overflow: "hidden", height: "var(--app-height)" }}
        >
          <Box
            className="mainLayout"
            sx={{ display: "flex", overflow: "hidden" }}
          >
            <MainLayout />

            <Box component="main" sx={{ flexGrow: 1, p: 1 }}>
              <DrawerHeader />

              <div id="mainHome">
                <div style={{overflow:"auto",height:"100%"}}>
                <div style={{marginTop:"2rem",maxWidth:"90%"}} class="container">
                  <div class="row">
                   <Card loading ={loading} subtitle="No. of messages​" value={CompliantData.length || 0} count={10}  title='Total Number' className='bg-c-yellow'/>
                   <Card loading ={loading} subtitle="No. of messages" value={CompliantLength} count={10}  title='Compliant' className='bg-c-pink'/>
                   <Card loading ={loading} subtitle="No. of messages" value={NonCompliantLength} count={10}  title='Non-Compliant' className='bg-c-green'/>
                   {/* <Card loading ={loading} subtitle="No of messages" value={10} count={10}  title='Compliance Assessment' className='bg-c-pink'/> */}

                  </div>

                  <div style={{display:"grid",gap:"1rem"}}>
                    <div>
                      <span style={{paddingBottom:"15px",display:"block",fontWeight:"600"}}>Compliance Assessment</span>
                      <Table 
                          headersData={compliance_assessment_header}
                          header="bg-c-orange-table"
                          tableData={outputData && outputData['data']['compliance_assessment']}
                          loading={loading}

                      />
                    </div>

                    <div>
                      <span style={{paddingBottom:"15px",display:"block",fontWeight:"600"}}>Identified Violations</span>
                      <Table 
                          headersData={compliance_assessment_header}
                          header="bg-c-yellow-table"
                          tableData={outputData && outputData['data']['identified_violations']}
                          loading={loading}

                      />
                    </div>

                    <div>
                      <span style={{paddingBottom:"15px",display:"block",fontWeight:"600"}}>Suggested Corrections</span>
                      <Table 
                          headersData={compliance_assessment_header}
                          header="bg-c-red-table"
                          tableData={outputData && outputData['data']['suggested_corrections']}
                          loading={loading}
                      />
                    </div>
                  </div>
                
                </div>
                </div>
               
              </div>
            </Box>
          </Box>
        </div>
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <Login />
      </UnauthenticatedTemplate>
    </>
  );
};

export default Output;
